<!-- Header -->
<div class="card mb-3">
  <div class="card-body py-3 d-flex align-items-center gap-2">
    <mat-icon class="header-icon">local_shipping</mat-icon>
    <h2 class="module-title mb-0">Gestionar OPs transportadora</h2>
  </div>
</div>

<mat-tab-group class="ops-tabs" animationDuration="200ms">
<mat-tab label="Gestión de OPs">
<ng-template matTabContent>

<!-- Panel de acciones -->
<div class="card mb-3">
  <div class="card-header d-flex align-items-center gap-2">
    <mat-icon class="section-icon">tune</mat-icon>
    <span class="section-title">Acciones</span>
  </div>
  <div class="card-body">
    <div class="actions-grid">

      <!-- Select Transporte con búsqueda (multiple) -->
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Transporte</mat-label>
        <mat-select [formControl]="transporteSeleccionado" multiple>
          <mat-select-trigger>
            <ng-container [ngSwitch]="(transporteSeleccionado.value || []).length">
              <span *ngSwitchCase="0">-- Seleccionar --</span>
              <span *ngSwitchCase="1">{{ transporteSeleccionado.value[0] }}</span>
              <span *ngSwitchDefault>{{ transporteSeleccionado.value.length }} transportes seleccionados</span>
            </ng-container>
          </mat-select-trigger>

          <!-- Búsqueda + seleccionar todos, fijos arriba del dropdown -->
          <mat-option disabled class="select-search-option">
            <input
              class="select-search-input"
              [formControl]="busquedaTransporte"
              placeholder="Buscar transporte..."
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()">
            <span
              class="select-all-toggle"
              *ngIf="transportesFiltrados.length > 0"
              (click)="$event.stopPropagation(); toggleSeleccionarTodosTransportes()">
              <mat-icon>{{ todosTransportesFiltradosSeleccionados ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
              Seleccionar todos{{ busquedaTransporte.value ? ' los filtrados' : '' }}
            </span>
          </mat-option>
          <mat-option *ngFor="let t of transportesFiltrados" [value]="t">{{ t }}</mat-option>
          <mat-option disabled *ngIf="transportesFiltrados.length === 0" class="no-results-option">
            Sin resultados
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="cargandoTransportes">
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
        <mat-hint *ngIf="cargandoTransportes">Cargando transportes...</mat-hint>
      </mat-form-field>

      <!-- Select transportadora con búsqueda -->
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>transportadora</mat-label>
        <mat-select [formControl]="clienteSeleccionado" [disabled]="!(transporteSeleccionado.value || []).length">
          <!-- Input de búsqueda dentro del dropdown -->
          <mat-option disabled class="select-search-option">
            <input
              class="select-search-input"
              [formControl]="busquedaCliente"
              placeholder="Buscar transportadora..."
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()">
          </mat-option>
          <mat-option value="">-- Seleccionar --</mat-option>
          <mat-option *ngFor="let c of clientesFiltrados" [value]="c.codigo">
            {{ c.nombre | titlecase }}
          </mat-option>
          <mat-option disabled *ngIf="clientesFiltrados.length === 0" class="no-results-option">
            Sin resultados
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="!(transporteSeleccionado.value || []).length">Selecciona uno o varios transportes primero</mat-hint>
      </mat-form-field>

      <!-- Select tipo de vehículo con búsqueda -->
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Tipo de vehículo</mat-label>
        <mat-select [formControl]="tipoVehiculoSeleccionado" [disabled]="!(transporteSeleccionado.value || []).length">
          <!-- Input de búsqueda dentro del dropdown -->
          <mat-option disabled class="select-search-option">
            <input
              class="select-search-input"
              [formControl]="busquedaTipoVehiculo"
              placeholder="Buscar tipo de vehículo..."
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()">
          </mat-option>
          <mat-option value="">-- Seleccionar --</mat-option>
          <mat-optgroup *ngFor="let tipo of tiposVehiculoFiltrados" [label]="tipo.nombre">
            <mat-option *ngFor="let v of tipo.valores" [value]="v.custom3">{{ v.custom3 }}</mat-option>
          </mat-optgroup>
          <mat-option disabled *ngIf="tiposVehiculoFiltrados.length === 0" class="no-results-option">
            Sin resultados
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="cargandoTiposVehiculo">
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
        <mat-hint *ngIf="!cargandoTiposVehiculo && !(transporteSeleccionado.value || []).length">Selecciona uno o varios transportes primero</mat-hint>
      </mat-form-field>

      <!-- Botones -->
      <div class="btn-group-actions">
        <button
          class="btn btn-primary btn-action"
          (click)="actualizarCliente()"
          [disabled]="!(transporteSeleccionado.value || []).length || !clienteSeleccionado.value"
          matTooltip="Actualiza la transportadora para todos los registros de los transportes seleccionados">
          <mat-icon>save</mat-icon>
          Actualizar transportadora
        </button>

        <button
          class="btn btn-warning btn-action"
          (click)="blanquearCliente()"
          [disabled]="!(transporteSeleccionado.value || []).length"
          matTooltip="Limpia el campo transportadora de todos los registros de los transportes seleccionados">
          <mat-icon>cleaning_services</mat-icon>
          Limpiar campo transportadora
        </button>

        <button
          class="btn btn-outline-secondary btn-action"
          (click)="limpiarFiltros()"
          matTooltip="Reinicia todos los filtros y selecciones">
          <mat-icon>restart_alt</mat-icon>
          Resetear
        </button>

        <button
          class="btn btn-enviar btn-action"
          (click)="enviarOpsManual()"
          matTooltip="Inicia el envío manual de OPs a Ditransa en segundo plano">
          <mat-icon>send</mat-icon>
          Enviar OPs Manual
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Tabla de OPs -->
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-2">
      <mat-icon class="section-icon">table_chart</mat-icon>
      <span class="section-title">Listado de OPs</span>
      <span class="badge-count" *ngIf="!cargandoTabla && !errorTabla">
        {{ dataSource.filteredData.length }} registro(s)
      </span>
    </div>

    <!-- Buscador -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar</mat-label>
      <input matInput [formControl]="busqueda" placeholder="Filtrar registros...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="card-body p-0">

    <!-- Estado: cargando -->
    <div class="state-container" *ngIf="cargandoTabla">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="state-text">Cargando OPs...</p>
    </div>

    <!-- Estado: error -->
    <div class="state-container state-error" *ngIf="!cargandoTabla && errorTabla">
      <mat-icon class="state-icon-error">error_outline</mat-icon>
      <p class="state-text">{{ errorTabla }}</p>
      <button class="btn btn-sm btn-outline-danger mt-2" (click)="cargarOps()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" *ngIf="!cargandoTabla && !errorTabla">
      <table mat-table [dataSource]="dataSource" matSort #sortOps="matSort" class="ops-table">

        <ng-container *ngFor="let col of columnas" [matColumnDef]="col.name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.title | uppercase }}</th>
          <td mat-cell *matCellDef="let row">
            <span
              [ngClass]="{
                'chip-transporte': col.name === 'TRANSPORTE' && row[col.name],
                'chip-null': row[col.name] === null || row[col.name] === '',
                'chip-cliente': col.name === 'CLIENTE' && row[col.name],
                'chip-vehiculo': col.name === 'TIPO_VEHICULO' && row[col.name]
              }">
              {{ render(col, row) }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="ops-row"></tr>

        <!-- Sin resultados -->
        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            <mat-icon>search_off</mat-icon>
            <span>No se encontraron registros{{ busqueda.value ? ' para "' + busqueda.value + '"' : '' }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="card-footer p-0" *ngIf="!cargandoTabla && !errorTabla">
    <mat-paginator
      #paginatorOps
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="25"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

</ng-template>
</mat-tab>

<mat-tab label="Histórico de Envío">
<ng-template matTabContent>

<!-- Panel de filtros del histórico -->
<div class="card mb-3">
  <div class="card-header d-flex align-items-center gap-2">
    <mat-icon class="section-icon">history</mat-icon>
    <span class="section-title">Filtrar histórico</span>
  </div>
  <div class="card-body">
    <div class="historico-filtros">

      <mat-radio-group [formControl]="modoFechaHistorico" class="modo-toggle">
        <mat-radio-button value="especifica">Fecha específica</mat-radio-button>
        <mat-radio-button value="rango">Rango de fechas (máx. 7 días)</mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" *ngIf="modoFechaHistorico.value === 'especifica'" class="field-fecha">
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="pickerEspecifica" [formControl]="fechaEspecificaHistorico">
        <mat-datepicker-toggle matSuffix [for]="pickerEspecifica"></mat-datepicker-toggle>
        <mat-datepicker #pickerEspecifica></mat-datepicker>
      </mat-form-field>

      <ng-container *ngIf="modoFechaHistorico.value === 'rango'">
        <mat-form-field appearance="outline" class="field-fecha">
          <mat-label>Desde</mat-label>
          <input matInput [matDatepicker]="pickerInicio" [formControl]="fechaInicioRangoHistorico">
          <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicio></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-fecha">
          <mat-label>Hasta</mat-label>
          <input
            matInput
            [matDatepicker]="pickerFin"
            [formControl]="fechaFinRangoHistorico"
            [min]="fechaInicioRangoHistorico.value"
            [max]="fechaFinRangoMax">
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
        </mat-form-field>
      </ng-container>

      <mat-radio-group [formControl]="filtroReintentoHistorico" class="modo-toggle">
        <mat-radio-button value="sin_reintento">Sin reintento</mat-radio-button>
        <mat-radio-button value="con_reintento">Con reintento</mat-radio-button>
        <mat-radio-button value="todos">Todos los envíos</mat-radio-button>
      </mat-radio-group>

      <div class="btn-group-actions">
        <button
          class="btn btn-primary btn-action"
          (click)="buscarHistoricoEnvio()"
          [disabled]="cargandoHistorico || (modoFechaHistorico.value === 'rango' && rangoHistoricoExcedeLimite)"
          matTooltip="Consulta el histórico de envío para la fecha o rango seleccionado">
          <mat-icon>search</mat-icon>
          Buscar
        </button>
        <button
          class="btn btn-outline-secondary btn-action"
          (click)="limpiarFiltrosHistorico()"
          matTooltip="Reinicia los filtros del histórico">
          <mat-icon>restart_alt</mat-icon>
          Resetear
        </button>
      </div>
    </div>

    <div *ngIf="modoFechaHistorico.value === 'rango' && rangoHistoricoExcedeLimite" class="rango-warning">
      <mat-icon>warning</mat-icon> El rango seleccionado supera los 7 días permitidos.
    </div>
  </div>
</div>

<!-- Resumen general -->
<div class="card mb-3" *ngIf="historicoConsultado">
  <div class="card-header d-flex align-items-center gap-2">
    <mat-icon class="section-icon">summarize</mat-icon>
    <span class="section-title">Resumen general</span>
    <span class="badge-count" *ngIf="!cargandoResumenHistorico && resumenHistoricoGrupos.length">
      {{ resumenHistoricoGrupos.length }} envío(s)
    </span>
  </div>
  <div class="card-body">

    <div class="state-container" *ngIf="cargandoResumenHistorico">
      <mat-spinner diameter="32"></mat-spinner>
      <p class="state-text">Cargando resumen...</p>
    </div>

    <div class="respuesta-sin-datos" *ngIf="!cargandoResumenHistorico && !resumenHistoricoGrupos.length">
      No hay información de resumen disponible para el filtro seleccionado.
    </div>

    <div class="resumen-grupo" *ngFor="let grupo of resumenHistoricoGrupos; let last = last" [class.mb-4]="!last">
      <div class="resumen-grupo-header">
        <div class="estado-banner" [ngClass]="grupo.success ? 'estado-success' : 'estado-error'">
          <mat-icon>{{ grupo.success ? 'check_circle' : 'cancel' }}</mat-icon>
          <span>{{ grupo.success ? 'Envío exitoso' : 'Envío con errores' }} · {{ grupo.status || grupo.statusCode }}</span>
        </div>
        <div class="resumen-grupo-meta">
          <span class="chip-pedido">{{ grupo.repeticiones }} registro(s)</span>
          <span class="resumen-grupo-fecha">{{ grupo.fechaEnvio | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>

      <div class="respuesta-sin-datos" *ngIf="grupo.parseError">
        No se pudo interpretar la respuesta de este envío.
      </div>

      <div class="grupos-pedidos" *ngIf="!grupo.parseError">

        <mat-expansion-panel class="grupo-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="grupo-icon grupo-added">add_circle_outline</mat-icon>
              Agregados
            </mat-panel-title>
            <mat-panel-description>{{ grupo.added.length }} pedido(s)</mat-panel-description>
          </mat-expansion-panel-header>
          <div class="chips-pedidos" *ngIf="grupo.added.length; else sinAddedGeneral">
            <span class="chip-pedido" *ngFor="let pedido of grupo.added">{{ pedido }}</span>
          </div>
          <ng-template #sinAddedGeneral><span class="sin-registros">Sin pedidos agregados.</span></ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel class="grupo-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="grupo-icon grupo-edited">edit</mat-icon>
              Editados
            </mat-panel-title>
            <mat-panel-description>{{ grupo.edited.length }} pedido(s)</mat-panel-description>
          </mat-expansion-panel-header>
          <div class="chips-pedidos" *ngIf="grupo.edited.length; else sinEditedGeneral">
            <span class="chip-pedido" *ngFor="let pedido of grupo.edited">{{ pedido }}</span>
          </div>
          <ng-template #sinEditedGeneral><span class="sin-registros">Sin pedidos editados.</span></ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel class="grupo-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="grupo-icon grupo-skipped">block</mat-icon>
              Omitidos
            </mat-panel-title>
            <mat-panel-description>{{ grupo.skipped.length }} pedido(s)</mat-panel-description>
          </mat-expansion-panel-header>
          <div class="chips-pedidos" *ngIf="grupo.skipped.length; else sinSkippedGeneral">
            <span class="chip-pedido" *ngFor="let pedido of grupo.skipped">{{ pedido }}</span>
          </div>
          <ng-template #sinSkippedGeneral><span class="sin-registros">Sin pedidos omitidos.</span></ng-template>
        </mat-expansion-panel>

      </div>
    </div>
  </div>
</div>

<!-- Tabla de histórico -->
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-2">
      <mat-icon class="section-icon">table_chart</mat-icon>
      <span class="section-title">Registros de envío</span>
      <span class="badge-count" *ngIf="!cargandoHistorico && !errorHistorico && historicoConsultado">
        {{ historicoDataSource.filteredData.length }} registro(s)
      </span>
    </div>

    <div class="d-flex align-items-center gap-2" *ngIf="historicoConsultado">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Buscar</mat-label>
        <input matInput [formControl]="busquedaHistorico" placeholder="Filtrar registros...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <button
        class="btn btn-outline-secondary btn-action"
        (click)="exportarHistoricoExcel()"
        [disabled]="!historicoDataSource.filteredData.length"
        matTooltip="Descarga el listado filtrado en Excel">
        <mat-icon>download</mat-icon>
        Exportar
      </button>
    </div>
  </div>

  <div class="card-body p-0">

    <!-- Estado: sin consultar -->
    <div class="state-container" *ngIf="!cargandoHistorico && !errorHistorico && !historicoConsultado">
      <mat-icon class="state-icon-idle">event_available</mat-icon>
      <p class="state-text">Selecciona una fecha o un rango y presiona "Buscar" para ver el histórico.</p>
    </div>

    <!-- Estado: cargando -->
    <div class="state-container" *ngIf="cargandoHistorico">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="state-text">Cargando histórico...</p>
    </div>

    <!-- Estado: error -->
    <div class="state-container state-error" *ngIf="!cargandoHistorico && errorHistorico">
      <mat-icon class="state-icon-error">error_outline</mat-icon>
      <p class="state-text">{{ errorHistorico }}</p>
      <button class="btn btn-sm btn-outline-danger mt-2" (click)="buscarHistoricoEnvio()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" *ngIf="!cargandoHistorico && !errorHistorico && historicoConsultado">
      <table mat-table [dataSource]="historicoDataSource" matSort #sortHistorico="matSort" class="ops-table">

        <ng-container *ngFor="let col of columnasHistorico" [matColumnDef]="col.name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.title | uppercase }}</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="col.name === 'STATUS'"
              class="chip-estado"
              [ngClass]="row.STATUS === 'SUCCESS' ? 'chip-estado-success' : 'chip-estado-error'"
              [matTooltip]="'Código ' + row.STATUS_CODE">
              {{ row.STATUS }}
            </span>
            <span *ngIf="col.name === 'FECHA_ENVIO'">{{ row.FECHA_ENVIO | date: 'dd/MM/yyyy HH:mm' }}</span>
            <span *ngIf="col.name === 'REINTENTO'"
              class="chip-estado"
              [ngClass]="row.REINTENTO === 'S' ? 'chip-estado-error' : 'chip-estado-success'">
              {{ row.REINTENTO === 'S' ? 'Reintento' : 'Primer envío' }}
            </span>
            <span *ngIf="col.name !== 'STATUS' && col.name !== 'FECHA_ENVIO' && col.name !== 'REINTENTO'">{{ row[col.name] || '-' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="ACCIONES">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let row">
            <button class="btn-detalle" (click)="verDetalleHistorico(row)" matTooltip="Ver detalle del envío">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsHistorico; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsHistorico;" class="ops-row"></tr>

        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumnsHistorico.length">
            <mat-icon>search_off</mat-icon>
            <span>No se encontraron registros{{ busquedaHistorico.value ? ' para "' + busquedaHistorico.value + '"' : '' }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="card-footer p-0" *ngIf="!cargandoHistorico && !errorHistorico && historicoConsultado">
    <mat-paginator
      #paginatorHistorico
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="25"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

</ng-template>
</mat-tab>
</mat-tab-group>
